<template lang="pug">
div#home
  el-row
    div.bg(:style="MAIN.BACK_GROUND")
      div.video-home
        div.texto-home(v-if="!playInVideo")
          h1(v-html="MAIN.TITULO")
          div(v-if="MAIN.EXIBIR_IMPORTANTE", @click="redirect").aviso
            b IMPORTANTE!
            p Antes de iniciar o cadastro ou adquirir alguma ocupação de terras públicas estaduais leia essas informações. &nbsp
              font-awesome-icon.icon(icon="arrow-right")

    the-sicarf#sicarf

</template>

<script>
import TheSicarf from '@/screens/portal/publico/components/home/TheSicarf'
import { mapState } from 'vuex'

export default {
  components: {
    TheSicarf
  },
  data () {
    return {
      subtituloHome: 'Você pode fazer o seu cadastro e acompanhar' +
                     ' toda a análise do processo sem sair de casa.' +
                     ' O SiCARF é sinônimo de <strong>agilidade</strong>,' +
                     ' <strong>transparência</strong> e <strong>comodidade</strong>.',
      playInVideo: false,
      originHost: window.location.origin
    }
  },
  computed: {
    ...mapState({
      MAIN: state => state.userInterface.dadosEstado.PUBLICO.MAIN
    })
  },
  methods: {
    youtubeUrl () {
      return `https://www.youtube.com/embed/ROwCM1RJSts?modestbranding=1&playsinline=0
      &showinfo=0&enablejsapi=1&origin=${window.location.origin}&widgetid=1&autoplay=1`
    },
    play () {
      this.playInVideo = true
    },
    goScrollTo () {
      document
        .getElementById('sicarf')
        .scrollIntoView({
          block: 'start',
          behavior: 'smooth'
        })
    },
    redirect () {
      this.$router.push({
        name: 'observacoesImportantes'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .icon {
    padding-top: 2px;
    font-weight: bold;
  }
  .aviso {
    border-radius: 10px;
    background-color: rgba(255, 255, 255, 0.1);
    width: 75%;
    margin: auto;
    cursor: pointer;
    padding: 20px 0 0 0;
    color: orange;
    font-size: 1.2em;
  }

  .aviso p {
    padding: 10px;
    font-size: 1.1em;
    color: white;
  }

  .video {
    width: 640px;
    height: 360px;
    border-top-width: 0px;
    border-right-width: 0px;
    border-bottom-width: 0px;
    border-left-width: 0px;
  }
  .padding-top-video {
    padding-top: 80px;
  }
  .padding-icone {
    padding-top: 10px;
  }
  .play {
    width: 81px;
    height: 81px;
    // cursor: pointer;
  }
  .bg {
    height: 50vh;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
  }

  @media (max-width: 1256px) {
  .bg {
      height: 100vh;
    }
  }

  .texto-home h1 {
    margin: auto;
    color: white;
  }
  .video-home {
    width: 100%;
    text-align: center;
    margin: 0;
    position: absolute;
    top: 33%;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    color: white;
  }
  .titulo p {
    line-height: 1;
    font-size: 44px;
    font-weight: bold;
    margin: auto;
  }
  .sub-titulo {
    margin: auto;
    p {
      font-size: 18px;
    }
  }
  .my-float.fa {
    font-size: 40px;
  }
  .float-button {
    cursor: pointer;
    position: absolute;
    bottom: 40px;
    color: white;
    left: 50%;
    right: 50%;
    height: 70px;
    margin-right: -35px;
    width: 80px;
    margin-left: -40px;
    display: block;
    align-items: center;
    text-align: center;
  }

  @media screen and (max-width: 768px) {
    .titulo p {
      font-size: 28px;
    }
    .sub-titulo p {
      font-size: 15px;
    }
  }

   @media screen and (max-width: 375px) {
    .float-button {
      font-size: 15px;
    }
  }

  @media screen and (min-width: 1220px) {
    .titulo p {
      font-size: 50px;
    }
    .sub-titulo {
      font-size: 20px;
    }
    .video-home {
      padding: 0 7%;
    }
  }
  @media screen and (min-width: 1440px) {
    .titulo p {
      font-size: 60px;
    }
    .sub-titulo {
      font-size: 22px;
    }
    .video-home {
      padding: 0 11%;
    }
  }

  @media (max-width: 425px) {
    #hiddenslider {
      display: none;
    }
  }

  @media (max-width: 375px) {
    #hiddenslider {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/screens/portal/publico/Home.vue